export class User {
    constructor(
        public name: string,
        public email: string,
        public profileImage: string,
        public gender: string,
        public role: string,
        public timezone: any,
        private _token: string,
        private _tokenExpirationDate: Date,
    ) {}

    get token() {

        if(!this._tokenExpirationDate || this.currentUTCTime > this._tokenExpirationDate) {
            return null;
        }
        return this._token;
    }

    get currentUTCTime() {
        const currentDateTime = new Date();
        const now_utc =  Date.UTC(currentDateTime.getUTCFullYear(), currentDateTime.getUTCMonth(), currentDateTime.getUTCDate(),
        currentDateTime.getUTCHours(), currentDateTime.getUTCMinutes(), currentDateTime.getUTCSeconds());
        const currentUTCDateTime = new Date(now_utc);

        return currentUTCDateTime;
    }
}
